import React from 'react';

export default function Wrapper({children, className, parent="dashboard"}) {
  return <div className={`${parent}__${className}`} style={{gridArea: className}}>
      {children}
  </div>
}
